import HomeHeader from "containers/Home/HomeHeader/HomeHeader";
import React, { useState, useEffect } from "react";
import UserDetailsHeader from "./UserDetailsHeader/UserDetailsHeader";
import "../UserDetails/UserDetails.css";
import InputBar from "components/InputBar/InputBar";
import SelectInput from "components/SelectInput/SelectInput";
import Button from "components/Button/Button";
import {
  getUserHashToken,
  getUserPhone,
  getVendingMachineUuid,
} from "utils/commonMethods";
import { API_KEYS } from "constants/apiEndpoints";
import { APP_ROUTES } from "constants/routes";

function UserDetails(props) {
  const componentTexts = window.appTexts.components.user_details_form;
  const initialState = {};
  const [state, setState] = useState(initialState);
  const [data, setData] = useState(props.location.state.data);

  const onChangeHandler = (name, value) => {
    setState({ ...state, [name]: value });
  };

  const submitHandler = () => {
    props.history.push(APP_ROUTES.HOME_PAGE.url);
  };

  const userRequestBody = {
    ...state,
    phone_no: getUserPhone(),
    hash: getUserHashToken(),
    uuid: getVendingMachineUuid(),
  };
  return (
    <>
      <UserDetailsHeader vmName={"logo"} />
      <section className="flex-container-space-between">
        <div>
          <p>{componentTexts.details_requirement}</p>
          <span>{getUserPhone()}</span>
        </div>
        <div className="edit_number">
          <br />
          <br />
          <span>Edit Number</span>
        </div>
      </section>
      <section className="flex-container">
        {data?.map((ele) => (
          <div className="input-area">
            {ele.key === "gender" ? (
              <SelectInput
                name={ele.key}
                type="select"
                customClassName="input-bar"
                value={state[ele.key]}
                options={[
                  {
                    name: "MALE",
                    value: "MALE",
                  },
                  {
                    name: "FEMALE",
                    value: "FEMALE",
                  },
                ]}
                onChange={onChangeHandler}
                inputProps={{
                  placeholder: "Gender",
                }}
              />
            ) : (
              <InputBar
                type={ele.type === "integer" ? "number" : "text"}
                name={ele.key}
                customClassName="input-bar"
                value={state[ele.key]}
                onChange={onChangeHandler}
                inputProps={{
                  placeholder: ele.key[0].toUpperCase() + ele.key.substring(1),
                }}
              />
            )}
          </div>
        ))}

        <div className="user-details-button">
          <Button
            onClick={submitHandler}
            loaderApiKey={API_KEYS.CREATE_USER_DETAILS}
            apiRequestBody={userRequestBody}
          >
            Continue
          </Button>
        </div>
      </section>
    </>
  );
}
export default UserDetails;
